import ApiService from "../ApiService";
const user = JSON.parse(localStorage.getItem("user"));

export default class ProductService {
  static getModule = async (params) => {
    const instance = await ApiService();
    return instance.get("/module");
  };

  static getData = async (params) => {
    console.log(params);
    let tenant_id =
      user.type === "tenant"
        ? `tenant_id=${user.tenant.id}`
        : params.tenant_id
        ? `tenant_id=${params.tenant_id}`
        : "";

    let category_id, page, perPage, deleted, keyword, property_id;
    if (params.category_id && params.category_id !== "") {
      category_id = `&category_id=${params.category_id}`;
    }

    if (params.page && params.page !== "") {
      page = `&page=${params.page}`;
    }
    if (params.perPage && params.perPage !== "") {
      perPage = `&per_page=${params.perPage}`;
    }
    if (params.deleted && params.deleted !== "") {
      deleted = `&deleted=${params.deleted}`;
    } else {
      deleted = `&deleted=false`;
    }
    // console.log(params);
    // console.log(property_id);
    // console.log(params.property_id);
    if (params.property_id && params.property_id !== "") {
      property_id = `&property_id=${params.property_id}`;
    }
    if (params.property_id === 0) {
      property_id = `&property_id=${params.property_id}`;
    }
    if (params.keyword && params.keyword !== "") {
      keyword = `&keyword=${params.keyword}`;
    }

    if (
      user.type === "tenant" ||
      (user.type === "staff" && params.tenant_id !== "")
    ) {
      const instance = await ApiService();
      return instance.get(
        `/product?${tenant_id}${category_id || ""}${page || ""}${
          perPage || ""
        }${deleted || ""}${keyword || ""}${property_id || ""}`
      );
    } else {
      return {
        data: [],
      };
    }
  };

  static getResume = async (params) => {
    let tenant_id =
      user.type === "tenant"
        ? `tenant_id=${user.tenant.id}`
        : params.tenant_id
        ? `tenant_id=${params.tenant_id}`
        : "";
    let category_id, keyword, type, property_id;
    if (params.category_id && params.category_id !== "") {
      category_id = `&category_id=${params.category_id}`;
    }
    if (params.keyword && params.keyword !== "") {
      keyword = `&keyword=${params.keyword}`;
    }
    if (params.type && params.type !== "") {
      type = `&type=${params.type}`;
    }
    if (params.property_id && params.property_id !== "") {
      property_id = `&property_id=${params.property_id}`;
    }

    if (
      user.type === "tenant" ||
      (user.type === "staff" && params.tenant_id !== "")
    ) {
      const instance = await ApiService();
      return instance.get(
        `/product/resume?${tenant_id}${category_id || ""}${keyword || ""}${
          property_id || ""
        }${type || ""}`
      );
    } else {
      return {
        data: [],
      };
    }
  };
  static getResumeCurrated = async (params) => {
    let tenant_id =
      user.type === "tenant"
        ? `tenant_id=${user.tenant.id}`
        : params.tenant_id
        ? `tenant_id=${params.tenant_id}`
        : "";
    let category_id, keyword, type;
    if (params.category_id && params.category_id !== "") {
      category_id = `&category_id=${params.category_id}`;
    }
    if (params.keyword && params.keyword !== "") {
      keyword = `&keyword=${params.keyword}`;
    }
    if (params.type && params.type !== "") {
      type = `&type=${params.type}`;
    }

    if (
      user.type === "tenant" ||
      (user.type === "staff" && params.tenant_id !== "")
    ) {
      const instance = await ApiService();
      return instance.get(
        `/product/curated/resume?${tenant_id}${category_id || ""}${
          keyword || ""
        }${type || ""}`
      );
    } else {
      return {
        data: [],
      };
    }
  };

  static getDataProduct = async (params) => {
    const instance = await ApiService();
    return instance.get(`/product/${params}`);
  };

  static storeData = async (value) => {
    const instance = await ApiService();
    console.log(value);
    let params = {
      name: value.name,
      product_code: value.product_code,
      description: value.description,
      category: value.shopfront,
      product_type_id: value.master_category.id,
      tenant: value.tenant,
      price: { currency: "IDR", value: parseFloat(value.price) },
      discounted_price: parseFloat(value.discounted_price),
      image_urls: value.image_urls,
      main_image: value.main_image,
      stock: parseFloat(value.stock),
      max_qty: parseFloat(value.max_qty),
      weight: parseFloat(value.weight),
      dimension: {
        length: parseFloat(value.dimension_length),
        width: parseFloat(value.dimension_width),
        height: parseFloat(value.dimension_height),
      },
    };
    return instance.post(`/product`, params);
  };

  static put = async (id, value) => {
    console.log(value);
    const instance = await ApiService();
    let params = {
      // id: value.id,
      name: value.name,
      product_code: value.product_code,
      description: value.description,
      category: value.shopfront,
      product_type_id: value.master_category.id,
      tenant: value.tenant,
      price: { currency: "IDR", value: parseFloat(value.price) },
      discounted_price: parseFloat(value.discounted_price),
      image_urls: value.image_urls,
      main_image: value.main_image,
      stock: parseFloat(value.stock),
      max_qty: parseFloat(value.max_qty),
      weight: parseFloat(value.weight),
      dimension: {
        length: parseFloat(value.dimension_length),
        width: parseFloat(value.dimension_width),
        height: parseFloat(value.dimension_height),
      },
    };
    return instance.put(`/product/${id}`, params);
  };

  static patch = async (id, params) => {
    const instance = await ApiService();
    return instance.patch(`/product/${id}`, params);
  };

  static delete = async (id) => {
    const instance = await ApiService();
    return instance.delete(`/product/${id}`);
  };
  static bulkDelete = async (params) => {
    const instance = await ApiService();
    return instance.post(`/product/bulkdelete`, params);
  };
  static deleteCurrated = async (id) => {
    const instance = await ApiService();
    return instance.delete(`/product/curated/${id}`);
  };
  static deleteRecommendation = async (id) => {
    const instance = await ApiService();
    return instance.delete(`/product/recommendation/${id}`);
  };

  static currated = async (params) => {
    const instance = await ApiService();
    return instance.post(`/product/curated`, params);
  };
  static POSTrecommendation = async (params) => {
    const instance = await ApiService();
    return instance.post(`/product/recommendation`, params);
  };
  // static GETcurrated = async () => {
  //   const instance = await ApiService();
  //   return instance.get(`/product/curated`);
  // };
  static GETcurrated = async (params) => {
    console.log(params);
    let tenant_id =
      user.type === "tenant"
        ? `tenant_id=${user.tenant.id}`
        : params.tenant_id
        ? `tenant_id=${params.tenant_id}`
        : "";

    let category_id, page, perPage, deleted, keyword, property_id, curated_type;
    if (params.category_id && params.category_id !== "") {
      category_id = `&category_id=${params.category_id}`;
    }
    if (params.curated_type && params.curated_type !== "") {
      curated_type = `&curated_type=${params.curated_type}`;
    }

    if (params.page && params.page !== "") {
      page = `&page=${params.page}`;
    }
    if (params.perPage && params.perPage !== "") {
      perPage = `&per_page=${params.perPage}`;
    }
    if (params.deleted && params.deleted !== "") {
      deleted = `&deleted=${params.deleted}`;
    } else {
      // deleted = `&deleted=false`;
    }
    // console.log(params);
    // console.log(property_id);
    // console.log(params.property_id);
    if (params.property_id === 0 && params.property_id !== "") {
      property_id = `&property_id=${params.property_id}`;
    }
    if (params.keyword && params.keyword !== "") {
      keyword = `&keyword=${params.keyword}`;
    }

    if (
      user.type === "tenant" ||
      (user.type === "staff" && params.tenant_id !== "")
    ) {
      const instance = await ApiService();
      return instance.get(
        `/product/curated?${tenant_id}${category_id || ""}${page || ""}${
          perPage || ""
        }${deleted || ""}${keyword || ""}${property_id || ""}${
          curated_type || ""
        }`
      );
    } else {
      return {
        data: [],
      };
    }
  };
  static GETrecommendation = async (params) => {
    console.log(params);
    let tenant_id =
      user.type === "tenant"
        ? `tenant_id=${user.tenant.id}`
        : params.tenant_id
        ? `tenant_id=${params.tenant_id}`
        : "";

    let category_id, page, perPage, deleted, keyword, property_id, recom_type;
    if (params.category_id && params.category_id !== "") {
      category_id = `&category_id=${params.category_id}`;
    }
    if (params.recom_type && params.recom_type !== "") {
      recom_type = `&recom_type=${params.recom_type}`;
    }

    if (params.page && params.page !== "") {
      page = `&page=${params.page}`;
    }
    if (params.perPage && params.perPage !== "") {
      perPage = `&per_page=${params.perPage}`;
    }
    if (params.deleted && params.deleted !== "") {
      deleted = `&deleted=${params.deleted}`;
    } else {
      // deleted = `&deleted=false`;
    }
    // console.log(params);
    // console.log(property_id);
    // console.log(params.property_id);
    if (params.property_id && params.property_id !== "") {
      property_id = `&property_id=${params.property_id}`;
    }

    if (params.keyword && params.keyword !== "") {
      keyword = `&keyword=${params.keyword}`;
    }

    if (
      user.type === "tenant" ||
      (user.type === "staff" && params.tenant_id !== "")
    ) {
      const instance = await ApiService();
      return instance.get(
        `/product/recommendation?${tenant_id}${category_id || ""}${page || ""}${
          perPage || ""
        }${deleted || ""}${keyword || ""}${property_id || ""}${
          recom_type || ""
        }`
      );
    } else {
      return {
        data: [],
      };
    }
  };
}
